import withFavorites from '../hoc/withFavorites';
import FavoritesPage from '../pages/Favorites';

const Favorites = withFavorites(FavoritesPage);

export default Favorites;
